import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaHotel, FaGlobe, FaHeadset, FaTags } from 'react-icons/fa';
import { useEffect } from 'react';


const Booking = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className=" px-6 mt-44 mb-20 sm:px-8 lg:px-16 text-gray-800">
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl text-center md:text-4xl font-extrabold text-yellow-700 mb-12"
        >
          Hotel Booking with Vamika Tours
        </motion.h2>
        
        {/* Description */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
          className="text-center max-w-3xl mx-auto text-lg mb-16"
        >
          Discover and book your perfect stay with ease. Vamika Tours helps you find the best hotels worldwide with exclusive deals, 24/7 support, and a seamless experience.
        </motion.div>

        {/* Features Section */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-20">
          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white/40 backdrop-blur-md border border-white/20 rounded-2xl shadow-xl p-8 text-center"
          >
            <FaHotel className="text-5xl text-yellow-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-yellow-700">Wide Hotel Choices</h3>
            <p className="text-gray-600">Luxury, budget, resorts – we’ve got them all!</p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white/40 backdrop-blur-md border border-white/20 rounded-2xl shadow-xl p-8 text-center"
          >
            <FaTags className="text-5xl text-yellow-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-yellow-700">Exclusive Deals</h3>
            <p className="text-gray-600">Get unbeatable discounts and offers.</p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white/40 backdrop-blur-md border border-white/20 rounded-2xl shadow-xl p-8 text-center"
          >
            <FaHeadset className="text-5xl text-yellow-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-yellow-700">24/7 Assistance</h3>
            <p className="text-gray-600">Friendly support whenever you need it.</p>
          </motion.div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            className="bg-white/40 backdrop-blur-md border border-white/20 rounded-2xl shadow-xl p-8 text-center"
          >
            <FaGlobe className="text-5xl text-yellow-700 mx-auto mb-4" />
            <h3 className="text-xl font-semibold mb-2 text-yellow-700">Global Reach</h3>
            <p className="text-gray-600">Book hotels in 100+ countries instantly.</p>
          </motion.div>
        </div>

        {/* Call To Action */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          <h3 className="text-2xl font-bold mb-4 text-yellow-700">Need Help Planning Your Trip?</h3>
          <p className="text-gray-700 mb-6">Our travel experts are here to guide you from start to finish.</p>
          <button
            onClick={() => navigate('/contact')}
            className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-white font-semibold px-8 py-3 rounded-full shadow-lg hover:shadow-2xl transition duration-300"
          >
            📞 Contact Us Now
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default Booking;
